import create from 'zustand';

const [navStore] = create((set, get) => ({
  config: { scrollTimeout: 1500, linkWidth: 160, stickyScroll: false },
  setConfig: config => set({ config }),
  shouldScroll: true,
  timeoutScroll: () => {
    set({ shouldScroll: false });
    setTimeout(() => {
      set({ shouldScroll: true });
    }, get().config?.scrollTimeout);
  },
  currentSection: 0,
  activeLink: 0,
  setActiveLink: v => set({ activeLink: v }),
  setVisibleSections: (v, b) =>
    set(state => {
      const visibleSections = { ...state.visibleSections, [v]: b };

      const importantSections = Object.keys(visibleSections)
        .filter(el => visibleSections[el])
        .map(el => parseInt(el));

      const currentSection =
        importantSections.length > 1
          ? importantSections[1]
          : importantSections[0];

      return {
        visibleSections,
        currentSection,
        activeLink: state.shouldScroll ? currentSection : state.activeLink,
      };
    }),
}));

export default navStore;
